import fila from './filaRepository'
import parametrizacao from './parametrizacaoRepository'
import relatorioSolicitacao from './relatorioSolicitacaoRepository'
import solicitacao from './solicitacaoRepository'
import status from './statusRepository'
import supervisor from './supervisorRepository'
import upload from './uploadRepository'
import monitoramentoProtocolo from './monitoramentoProtocoloRepository'

export default baseUrl => {

    baseUrl = `${baseUrl}/regulacao`

    return {
        fila: fila(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        relatorioSolicitacao: relatorioSolicitacao(baseUrl),
        solicitacao: solicitacao(baseUrl),
        status: status(baseUrl),
        supervisor: supervisor(baseUrl),
        upload: upload(baseUrl),
        monitoramentoProtocolo: monitoramentoProtocolo(baseUrl),
    }
}